import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import type { components } from "@/api/schema";
import { ConfirmDialog } from "@/shared/components/ConfirmDialog";
import { toast } from "@/shared/lib/toast";

import { useCalculateReset } from "../api/use-calculate-reset";

type Marketplace = components["parameters"]["Marketplace"];

interface ResetRowConfirmProps {
  sku: string;
  marketplace: string;
  onClose: () => void;
}

export function ResetRowConfirm({ sku, marketplace, onClose }: ResetRowConfirmProps): JSX.Element {
  const { t } = useTranslation("inventory");
  const { mutate: resetDefaults, isPending } = useCalculateReset();

  function handleConfirm(): void {
    resetDefaults([{ sku, marketplace: marketplace as Marketplace }], {
      onSuccess: () => {
        toast.success(t("action.reset_defaults_done", { sku }));
        onClose();
      },
    });
  }

  return (
    <ConfirmDialog
      title={t("confirm.reset_row.title")}
      description={t("confirm.reset_row.description", { sku, mkp: marketplace })}
      onConfirm={handleConfirm}
      onCancel={onClose}
      isPending={isPending}
      confirmLabel={t("confirm.reset_row.action_reset")}
      cancelLabel={t("confirm.reset_row.action_cancel")}
    />
  );
}
